import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface SumStatsResponse {
  sumReps: number;
  sumKg: number;
  sumKm: number;
  sumKcal: number;
}

const queryOptions = (machineType: string, monthsAmount: number) => ({
  queryKey: ['sumstats', machineType, monthsAmount],
  queryFn: async () => {
    if (!machineType) {
      throw new Error('No machine type selected');
    }
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.post<SumStatsResponse>(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/sumstats`,
        { machineType, monthsAmount },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      return data;
    } catch (error: any) {
      if ( error.response && error.response.status === 401 && error.response.data.error === "Invalid or missing API key"
      ) { 
        logout()
      } 
      throw error;
    } 
  },
  enabled: !!machineType,
}) as any;

export const useSumStats = (machineType: string, monthsAmount: number) => {
  return useQuery<SumStatsResponse, Error>(queryOptions(machineType, monthsAmount));
};
